module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploading",
    style: (_vm.visible ? '' : 'display: none;')
  }, [_c('div', {
    staticClass: "uploading-wrapper"
  }, [_c('div', {
    staticClass: "uploading-spinner"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "lg",
      "text": _vm.image ? '' : 'Saving...'
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  })], 1), _vm._v(" "), (_vm.image) ? _c('div', {
    staticClass: "uploading-text"
  }, [(_vm.total > 1) ? [_vm._v("\n        Uploading file " + _vm._s(_vm.uploaded) + " of " + _vm._s(_vm.total) + "\n      ")] : [_vm._v("\n        Uploading file\n      ")]], 2) : _vm._e(), _vm._v(" "), (_vm.total > 1 && _vm.image) ? _c('b-progress', {
    attrs: {
      "precision": 0,
      "max": _vm.total,
      "show-progress": "",
      "animated": ""
    },
    model: {
      value: (_vm.uploaded),
      callback: function($$v) {
        _vm.uploaded = $$v
      },
      expression: "uploaded"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12498e65","hasScoped":true}!./src/components/uploading/uploading.component.html
// module id = 536
// module chunks = 1